define(
    'plugins/musicfavourite/ui/dialogs/upsell',['idcta/idcta-1', '../dom', '../../env', './dialog', 'exports'],
    function(idcta, DOM, Environment, Dialog, exports) {

        'use strict';

        function getPropertyFromElement(element, propertyName) {
            var selector = 'input[name=' + propertyName + ']';
            var matchingInputElements = DOM.findElement(selector, element);
            return (matchingInputElements.length) ? DOM.getAttr(matchingInputElements, 'value') : undefined;
        }

        /**
         * Fully URL encode a string (including apostrophes and other non-reserved characters)
         * to comply with the RFC 3986 standard.
         *
         * @param   {string} str  String to be encoded.
         * @returns {string}      URL encoded string.
         */
        function fullyEncodeURIComponent(str) {
            return encodeURIComponent(str).replace(/[!'()*]/g, escape);
        }

        /**
         * Build the PTRT param to pass to IDCTA when determining the sign in/register button URLs.
         *
         * @param   {object} item  Item to be added after successful sign-in.
         * @returns {string}       PTRT param to be passed to the IDCTA API.
         */
        function getSignedInCallbackPtrt(item) {
            var playlistType = item.playlistType || getPropertyFromElement(item['element'], 'playlist-type');
            var contextType = item.contextType || getPropertyFromElement(item['element'], 'context-type');
            var contextId = item.contextId || getPropertyFromElement(item['element'], 'context-id');
            var platform = item.platform || getPropertyFromElement(item['element'], 'platform');
            var product = item.product || getPropertyFromElement(item['element'], 'product');
            var ptrt = item.ptrt || getPropertyFromElement(item['element'], 'ptrt') || document.URL;

            var queryParams = '?params[item]=' + fullyEncodeURIComponent(item.id)
                + (playlistType ? '&params[playlist-type]=' + playlistType : '')
                + (contextType ? '&params[context-type]=' + contextType : '')
                + (contextId ? '&params[context-id]=' + contextId : '')
                + (platform ? '&params[platform]=' + platform : '')
                + (product ? '&params[product]=' + product : '')
                + (ptrt ? '&params[ptrt]=' + ptrt : '');

            var url = Environment.resolveApiURL("/modules/plugin/musicfavourite/my/favourites/signedin.html" + queryParams);
            return fullyEncodeURIComponent(url);
        }

        /**
         * Retrieve a localised string based on a translation key.
         *
         * @param  {object} locales  Object containing translations.
         * @param  {string} key      Key for translation text.
         * @param  {string} lang     Language for lookup, defaults to "en-gb".
         * @return {string}          Translated text for key.
         */
        function getLocalisedString(locales, key, lang) {
            var category = 'upsell',
                translatedKeys;

            key = key || '';
            if (!lang || !locales[lang]) {
                lang = 'en-gb'; // Default to English
            }

            translatedKeys = locales[lang];
            if (translatedKeys[category] && translatedKeys[category][key]) {
                return translatedKeys[category][key];
            }

            return lang !== 'en-gb' && getLocalisedString(locales, key, 'en-gb') || key;
        }

        /**
         * Set the dialog profile based on the item's profile.
         *
         * @param item
         */
        function setDialogProfile(item) {
            var dialogWrapper = DOM.findElement('.p-f-dialog-wrapper'),
                currentDialogProfile = DOM.getAttr(dialogWrapper, 'data-profile');

            DOM.setAttr(dialogWrapper, 'data-profile', 'p-f-dialog-' + item.profile);
            var newDialogProfile = DOM.getAttr(dialogWrapper, 'data-profile');

            // If the dialog profile is already set and is different to the item profile then remove the old class before adding the new one
            if (currentDialogProfile && currentDialogProfile !== newDialogProfile) {
                DOM.removeClass(dialogWrapper, currentDialogProfile);
            }

            DOM.addClass(dialogWrapper, newDialogProfile);
        }

        /**
         * Make the close button on the dialog tab-able.
         */
        function setTabIndexOnDialog() {
            DOM.setAttr(DOM.findElement('.p-f-dialog-close'), 'tabindex', '5');
        }

        exports = {
            'renderUpsellDialog': function(item) {
                var upsellContentElement = DOM.findElement('.p-f-upsell'),
                    useSignInOverlay = item.useSigninOverlay,
                    ptrt = getSignedInCallbackPtrt(item),
                    lang = item.lang;

                var idctaContainer = DOM.findElement('.p-f-dialog-signin-buttons', upsellContentElement)[0];
                var idctaElementId = idctaContainer.firstElementChild.id;
                idcta.modifyPtrt(idctaElementId, ptrt);

                DOM.setAttr(DOM.findElement('.id4-cta-button', upsellContentElement), 'target', useSignInOverlay ? '_self' : '_blank');
                DOM.setAttr(DOM.findElement('.id4-cta-register', upsellContentElement), 'target', useSignInOverlay ? '_self' : '_blank');
                DOM.setHTML(DOM.findElement('.p-f-dialog-heading', upsellContentElement), getLocalisedString(item.text.dialog, 'heading', lang));
                DOM.setHTML(DOM.findElement('.p-f-dialog-text', upsellContentElement), getLocalisedString(item.text.dialog, 'text', lang));
                DOM.setHTML(DOM.findElement('.p-f-dialog-signin-post-text', upsellContentElement), getLocalisedString(item.text.dialog, 'signInText4', lang));

                var upsellContent = DOM.getHTML(upsellContentElement);
                Dialog.setContent(upsellContent, function() {
                    setDialogProfile(item);
                    if(item.useModalSignin) {
                        Dialog.show(item['button'][0]);
                    } else {
                        Dialog.showAsTooltip(item['button'][0]);
                    }
                });

                // Add tab index to close button.
                setTabIndexOnDialog();
            }
        };

        return exports;
    }
);

